module.exports = __webpack_public_path__ + "img/VillaLoreto_Room1.1d25260f.jpg";